import * as actionType from './type';

const INITIAL_STATE = {
    isLoading: false,
    allNotification: [],
    isCreateEdit: false,
    isDialogLoading : false
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_SHOW_LOADER: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.REQUEST_HIDE_LOADER: {
            return {
                ...state,
                isLoading: false,
            }
        }
         
        case actionType.RECEIVED_ALL_NOTIFICATION: {
            return {
                ...state,
                allNotification: action?.payload
            }
        }

        case actionType?.CREATE_EDIT_CONFIGURATION: {
            return {
                ...state,
                isCreateEdit: action?.payload
            }
        }
        case actionType.REQUEST_SHOW_DIALOG_LOADER: {
            return {
                ...state,
                isDialogLoading: true
            }
        }

        case actionType.REQUEST_HIDE_DIALOG_LOADER: {
            return {
                ...state,
                isDialogLoading: false,
            }
        }
        default: 
            return state;
    }
}